// @flow

export function EUCookieBarShown() {
  return {
    type: 'EU_COOKIE_BAR_SHOWN',
    payload: {},
  };
}

export function EUCookieBarHide() {
  return {
    type: 'EU_COOKIE_BAR_HIDE',
    payload: {},
  };
}
